import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


export const calculateHotelProcessingFees = async (totalAmount, currency) => {
    try {
        const response = await api.post('/hotels/calculate-processing-fees', {
            totalAmount,
            currency,
            includeAxonalServiceFee: false
        });

        if (response.data?.success) {
            return {
                success: true,
                ...response.data.data
            };
        }

        throw new Error(response.data?.message || 'Failed to calculate hotel processing fees');
    } catch (error) {
        console.error('[HotelProcessingFeesService] API call failed:', {
            error: error.message,
            response: error.response?.data
        });
        throw error;
    }
};

export default {
    calculateHotelProcessingFees
};
